<template>
  <div class="xzj-wrapper">
      <img src="@/assets/images/xzj-xcb-banner.jpg" alt="">
      <a href="javascript:;" class="go-back s-activity-back" @click="e=>this.$router.back()"></a>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    .xzj-wrapper{
        width: 100%;
        position: absolute;
    }
    .xzj-wrapper img{width:100%}
    .xzj-wrapper .s-activity-back{top:30.67vw;}


</style>